module.exports = __webpack_public_path__ + "static/P2101491-11acaa6f3e0c1a36c74890205b36d2bb.jpg";